module.exports = __webpack_public_path__ + "img/cardinal-point.5a7bfeb2.png";